import axios from 'axios'
import env from '../../../env'

const PRODUCAO = env.VUE_APP_URL_PRODUCAO_BACKEND;
const DEVELOP = env.VUE_APP_URL_HOMOLOG_BACKEND;

const httpClient = axios.create({
    baseURL: process.env.NODE_ENV === 'production'? PRODUCAO : DEVELOP
})

class BackendConfigService {

    constructor(apiurl, headers){
        this.apiurl = apiurl;
        this.headers = headers;
    }

    post(url, objeto){
        const requestUrl = `${this.apiurl}${url}`
        return httpClient.post(requestUrl, objeto, {headers:this.headers})
    }

    patch(url, objeto){
        const requestUrl = `${this.apiurl}${url}`
        return httpClient.patch(requestUrl, objeto, {headers:this.headers})
    }

    put(url, objeto){
        const requestUrl = `${this.apiurl}${url}`
        return httpClient.put(requestUrl, objeto, {headers:this.headers})
    }

    delete(url){
        const requestUrl = `${this.apiurl}${url}`
        return httpClient.delete(requestUrl, {headers:this.headers})
    }

    get(url){
        const requestUrl = `${this.apiurl}${url}`
        return httpClient.get(requestUrl, {headers:this.headers})
    }

    get_base_url_agenda_saude(){
        return '/agenda-saude/api/v1'
    }

    get_base_url_backend(){
        return process.env.NODE_ENV === 'production'? PRODUCAO : DEVELOP
    }
}

export default BackendConfigService